import React from 'react';
import { ReactDatePickerProps } from 'react-datepicker';
import { BoxProps } from '@mui/material';

export type PickerProps = {
  label?: string;
  end: Date | number;
  start: Date | number;
};

export type DatePickerRangeProps = {
  onChange: (value: DateRangeType) => void;
  popperPlacement: ReactDatePickerProps['popperPlacement'];
};

export type DateRangeType = {
  startDate?: string;
  endDate?: string;
};

export type RefProps = {
  handleReset?: () => void;
};
